import {Form, Field, Formik} from 'formik';
import React, {useEffect, useState} from 'react';
import {useNavigate,useLocation} from 'react-router-dom';
import { Row} from 'reactstrap';
import {AppRoutes} from '../../Router';
import './login-firm-17.scss';
import * as Yup from "yup";
import {Fab} from '@mui/material';
import {typeIdentification} from '../../__mocks__/data';
import {MenuBar} from '../../components/shared/Menubar/Menubar';
import { useIntl } from 'react-intl';
import { useSignContext } from '../../hooks/useSignContext';
import { AuthService } from '../../services/AuthService';
import toast from 'react-hot-toast';
import ClockLoader from 'react-spinners/ClockLoader';
import { WLOCreditAPIService } from '../../services/WLOCreditService';
import { useRequestContext } from '../../hooks/useRequestContext';
import {useLoginContext} from '../../hooks/useLoginContext';

interface LoginFirmaProps {
}

const ESTADOS_PERMITEN_FIRMA = [0, 1, 2, 3, 12];
const MENSAJE_FIRMA_NO_DISPONIBLE = 'El enlace de firma ya no está disponible para esta solicitud.';

let verifyFirmaTokenPromise: Promise<any> | null = null;
let verifyFirmaTokenKey = '';

const verifyFirmaTokenOnce = (token: string) => {
    if (verifyFirmaTokenKey === token && verifyFirmaTokenPromise) {
        return verifyFirmaTokenPromise;
    }
    verifyFirmaTokenKey = token;
    verifyFirmaTokenPromise = AuthService.verifyFirmaToken({ token });
    return verifyFirmaTokenPromise;
};

const mostrarErrorEnlace = () => {
    toast.error(MENSAJE_FIRMA_NO_DISPONIBLE, { id: 'enlace-firma-invalido', duration: 5000 });
};

export function LoginFirma17(props: LoginFirmaProps) {
    let [isLoading, setIsLoading] = useState(false);
    const [validandoEnlace, setValidandoEnlace] = useState(true);
    const [enlaceValido, setEnlaceValido] = useState(false);
    const [numeroSolicitud, setNumeroSolicitud] = useState(0);
    const [valoreslogins, setvalores] = useState({}as any);
    const {user, setUser} = useLoginContext();
    const intl = useIntl();
    const {request, setRequest} = useRequestContext();
    const {sign, setSign} = useSignContext();
    const navigate = useNavigate();
    const buscar = useLocation();

    const handleSubmit = async (values: any) => {
        if (!enlaceValido || numeroSolicitud <= 0) {
            mostrarErrorEnlace();
            return;
        }
        setIsLoading(true);
        try {
            const validation = await AuthService.loginValidacion({
                Pws_Identificacion: values.Pws_Identificacion,
                Pws_Tip_identificacion: values.Pws_Tip_Identificacion,
                Pws_Correo:values.Pws_Correo,
                Pws_Telefono:values.Pws_Telefono
            });

            if (Number(validation.payload.result) > 0) {
                if(numeroSolicitud>0){
                    const solicitudResulado = await WLOCreditAPIService.addSolicitud({
                        Pws_num_solicitud:String(numeroSolicitud),
                        Pws_Identificacion: values.Pws_Identificacion,
                        Pws_Tip_Identificacion: values.Pws_Tip_Identificacion
                    });
                    localStorage.setItem('num_solicitud', solicitudResulado.payload.data.Datos_Sol.Datos_Sol[0].Pws_num_solicitud);
                    localStorage.setItem('identificacion', solicitudResulado.payload.data.Datos_Sol.Datos_Sol[0].Pws_Identificacion);
                    localStorage.setItem('tipoidentificacion', solicitudResulado.payload.data.Datos_Sol.Datos_Sol[0].Pws_Tip_Identificacion);
                    if(Number(solicitudResulado.payload.result)>0){
                        const estadoSolicitud = Number(
                            solicitudResulado.payload.data.Datos_Sol.Datos_Sol[0].Pws_Tip_Estado
                        );

                        if (!ESTADOS_PERMITEN_FIRMA.includes(estadoSolicitud)) {
                            setIsLoading(false);
                            toast.error(MENSAJE_FIRMA_NO_DISPONIBLE, { duration: 5000 });
                        } else {
                                if(Number(valoreslogins.tipodeudor)<2){
                                    solicitudResulado.payload.data.Datos_Sol.Datos_Sol[0].Pws_Tip_Estado="2"
                                    await WLOCreditAPIService.addSolicitud(solicitudResulado.payload.data.Datos_Sol.Datos_Sol[0])

                                }
                                 setRequest({
                                ...request,
                                numSol: String(numeroSolicitud),
                                personCygnus:solicitudResulado.payload.data.Datos_Sol.Datos_Sol[0],
                                valoresLogin:valoreslogins
                            });
                            setUser({
                                ...user,
                                idUser: values.Pws_Identificacion,
                                lastLoginDate: new Date().toDateString(),
                                isSuccessfulLogin: true
                            });
                                setSign({...sign, numIdentification: values.Pws_Identificacion,
                                typeIdentification: values.Pws_Tip_Identificacion,
                                email: values.Pws_Correo,
                                phoneNumber: values.Pws_Telefono,
                                identityValidated: true
                            })
                            setIsLoading(false);
                            navigate(AppRoutes.VIEW_DOCUMENT, {replace: true});
                        }
                    }else{
                        setIsLoading(false);
                        toast.error('No es el Numero de Solicitud de la persona',{
                            duration:5000,
                        });

                    }
                }else{
                    setIsLoading(false);
                    toast.error('No Cuentas con el Token',{
                        duration:5000,
                    });

                }


            } else {
                setSign({...sign, numIdentification: values.Pws_Identificacion,
                    typeIdentification: values.Pws_Tip_Identificacion,
                    email: values.Pws_Correo,
                    phoneNumber: values.Pws_Telefono,
                    identityValidated: false
                })
                setIsLoading(false);
                toast.error(intl.formatMessage({id: "toast_failed_identity_validation"},{
                    duration:5000,
                }));
            }
        } catch (error) {
            setIsLoading(false);
            toast.error('En este momento no podemos procesar su solicitud',{
                duration:5000,
            });
        }
    };
    useEffect(() => {
        let cancelled = false;

        const validarEnlace = async () => {
            setValidandoEnlace(true);
            setEnlaceValido(false);

            const token = buscar.search?.replace('?', '') ?? '';
            if (!token) {
                if (!cancelled) {
                    setValidandoEnlace(false);
                    mostrarErrorEnlace();
                }
                return;
            }

            try {
                const response = await verifyFirmaTokenOnce(token);
                if (cancelled) return;

                const valorde = response?.payload;
                if (valorde && Number(valorde.solicitudnum) > 0) {
                    localStorage.setItem('solicitud', JSON.stringify(valorde));
                    setNumeroSolicitud(Number(valorde.solicitudnum));
                    setvalores(valorde);
                    setEnlaceValido(true);
                } else if (!cancelled) {
                    setEnlaceValido(false);
                    mostrarErrorEnlace();
                }
            } catch {
                if (!cancelled) {
                    setEnlaceValido(false);
                    mostrarErrorEnlace();
                }
            } finally {
                if (!cancelled) setValidandoEnlace(false);
            }
        };

        validarEnlace();

        return () => {
            cancelled = true;
        };
    }, [buscar.search]);
    useEffect(() => {
        document.body.classList.add('body-login');
        return () => {
            document.body.classList.remove('body-login');
        };
    }, []);
    const initialValues = {
        Pws_Tip_Identificacion: '',
        Pws_Identificacion: '',
        Pws_Correo: '',
        Pws_Telefono: ''
    };

    const validationSchema = Yup.object().shape({
        Pws_Tip_Identificacion: Yup.string()
            .required('( * )'),
        Pws_Identificacion: Yup.string().required('( * )'),
        Pws_Correo: Yup.string()
            .required('( * )'),
        Pws_Telefono: Yup.string()
            .required('( * )'),
    })

    return (
        <div className="loginfirma17">
            <MenuBar/>
            <ClockLoader id='spinner' color={"#4FAE32"} loading={isLoading || validandoEnlace} size={100}/>
            <div className='loginfirm'>
                <div className='img-logo'/>
                <div className='title-login'>{'Antes que todo validemos tu identidad'}</div>
                <div className='subtitle-login'>
                    {!validandoEnlace && !enlaceValido
                        ? 'No es posible continuar con el proceso de firma'
                        : 'Ingresa los siguientes datos para continuar'}
                </div>
                <div className='login-container'>
                    {!validandoEnlace && !enlaceValido && (
                        <p className="firma-enlace-error" role="alert">
                            {MENSAJE_FIRMA_NO_DISPONIBLE}
                        </p>
                    )}
                    {enlaceValido && (
                    <Formik
                        initialValues={initialValues}
                        onSubmit={handleSubmit}
                        validationSchema={validationSchema}
                    >
                        {() => (
                            <>
                                <Form>
                                    <Row>
                                        <section>
                                            <Field as="select"
                                                disabled={isLoading || !enlaceValido}
                                                className='form-control-50-credit'
                                                name="Pws_Tip_Identificacion">
                                                <option>{'Tipo de documento'}</option>
                                                {typeIdentification && typeIdentification.WS_TIPOS_IDENTIFICACION_IResult.LstTiposIdent.Datos_TiposIdentificacion.map((item,i) => {
                                                    return (
                                                        <option key={i} value={item.s_codigo}>{item.s_descripcion}</option>
                                                    )
                                                })}
                                            </Field>
                                        </section>
                                        <section>
                                            <div className='form-control-login-text'>{'Documento'}</div>
                                            <Field
                                                className='form-control-50-credit'
                                                id="Pws_Identificacion"
                                                name="Pws_Identificacion"
                                                type="text"
                                                disabled={isLoading || !enlaceValido}
                                                placeholder='Número de documento'
                                            />
                                            <br/>
                                        </section>
                                        <section>
                                            <h4 className="title-firma">{'Inserta una dirección de correo electrónico y tu número de celular para  enviarte el código de validación.'}</h4>
                                            <Field
                                                className='form-control-50-credit'
                                                id="Pws_Correo"
                                                name="Pws_Correo"
                                                type="email"
                                                disabled={isLoading || !enlaceValido}
                                                placeholder='Correo electrónico'
                                            />
                                            <br/>
                                            <Field
                                                className='form-control-50-credit'
                                                id="Pws_Telefono"
                                                name="Pws_Telefono"
                                                type="text"
                                                disabled={isLoading || !enlaceValido}
                                                placeholder='Celular'
                                            />
                                            <br/>
                                        </section>
                                        <section>
                                            <Fab className="form-control-small-button" variant="extended" type='submit'
                                                size="medium"
                                                color="neutral" aria-label="add">
                                                {'Ingresar'}
                                            </Fab>
                                        </section>
                                    </Row>
                                </Form>
                            </>
                        )}
                    </Formik>
                    )}
                </div>
            </div>
        </div>
    )
}
